import defaultBranding from "./default";
import warriorTradingBranding from "./warrior-trading";
import { currentRuntime } from '../runtime';
import type { BrandingConfig } from "./types";

export const BRANDS: Record<string, BrandingConfig> = {
  default: defaultBranding,
  "trade-proof": defaultBranding,
  "warrior-trading": warriorTradingBranding,
};

export function getBranding(tenantId?: string): BrandingConfig {
  if (!tenantId) return defaultBranding;
  return BRANDS[tenantId] ?? defaultBranding;
}

export const branding: BrandingConfig = getBranding(currentRuntime.brand.id);

export default branding;

export type {
  BrandingConfig,
  LogoVariantSet,
  CompanyLogoVariantSet,
  LogoScaleConfig,
  LogoSizingSet,
  CompanyLogoSizingSet,
} from "./types";

export { defaultBranding, warriorTradingBranding };